type SiteBuyResponse = 'Ok' | 'Error' | 'Unknown';

class SiteElementBuy
    extends QueryElement<HTMLElement> 
    implements ISiteElementQuantityPickerSubmit {
    
    private readonly _id: string;
    private readonly _site: Site;
    private _listGroupId: string | null;

    constructor(element: HTMLElement, site: Site) {
        super(element);

        let id = this.getAttr("data-id");
        if (id == null)
            throw "ID not found!";

        this._id = id;
        this._listGroupId = this.getAttr("data-listGroupId");
        this._site = site;

        let quantityPicker = this.query(".quantity-picker")
            .createAll<ISiteElementQuantityPicker, HTMLElement>(a => new SiteElementQuantityPicker(a, this))
            .concat(this.query(".quantity-picker-number")
                .createAll<ISiteElementQuantityPicker, HTMLElement>(a => new SiteElementQuantityPickerNumber(a, this)));

        var x = 0;
        this.query(".element-price").create<IQueryElement, HTMLElement>(a => {
            var quantityPickerItem = quantityPicker[x];
            x++;
            
            if (quantityPickerItem == null)
                return null;
            
            return new SiteElementPrice(a, quantityPickerItem)
        });

        var customFields = this.query(".custom-fields").create<SiteElementCustomFields, HTMLElement>(a => new SiteElementCustomFields(a, this));
        this.query(".custom-fields-preview").create<IQueryElement, HTMLElement>(a => customFields && new SiteElementCustomFieldsPreview(a, customFields));

    }

    async submit(debtorId: string, quantity: number, customFields: {[key: string]: string}) : Promise<SiteBuyResponse> {
        let request = new QueryRequest(
            `/Cart/Create/${this._id}`, {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify({
                quantity: quantity,
                listGroupId: this._listGroupId,
                debtorId: debtorId,
                customFields: customFields
            })
        });

        var response = await request.request();
        var jsonResponse: IResponse = await response.json();
        switch(jsonResponse.type)
        {
            case "Cart":
            {
                let payLoad = <ICartPayloadResponse>jsonResponse.payLoad;
                if (payLoad.succeeded)
                {
                    this._site.eventAddedPreOrder();
                    return "Ok";
                }
                else
                {
                    return "Error";
                }
            }
            case "Message":
            {
                let payLoad = <IMessagePayloadResponse>jsonResponse.payLoad;
                this._site.addMessage(payLoad);

                if (payLoad.sort == "Info")
                {
                    this._site.eventAddedPreOrder();
                    return "Unknown";
                }
                else
                {
                    return "Error";
                }
            }
            default:
                return "Error";
        }
    }
}